import { useQuery } from '@apollo/client';
import { ATTENDEE_PDF_GROUPS_QUERY } from '@general/graphql/event.graph';

const useAttendeePdfs = eventCode => {
    const { data, loading } = useQuery(ATTENDEE_PDF_GROUPS_QUERY, {
        variables: { codes: [eventCode] },
        skip: !eventCode,
    });

    const pdfGroups = data?.events?.[0]?.attendeePdfGroups ?? [];

    return {
        pdfGroups,
        loading,
        isEmpty: !loading && pdfGroups.length === 0,
    };
};

export default useAttendeePdfs;
